import React from 'react';

type Props = {
  text?: string | null;
  className?: string;
};

function splitIntoSentences(text: string): string[] {
  return text
    .replace(/\s+/g, ' ')
    .trim()
    .split(/(?<=[.!?])\s+(?=[A-Z0-9])/);
}

function groupSentences(sentences: string[]): string[] {
  const paragraphs: string[] = [];
  let current = '';
  for (const s of sentences) {
    if ((current + ' ' + s).trim().length > 300 || current.split('.').length >= 3) {
      if (current.trim()) paragraphs.push(current.trim());
      current = s;
    } else {
      current = current ? current + ' ' + s : s;
    }
  }
  if (current.trim()) paragraphs.push(current.trim());
  return paragraphs.length ? paragraphs : sentences;
}

const FormattedSummary: React.FC<Props> = ({ text, className = '' }) => {
  if (!text) return null;

  const normalized = String(text).replace(/\r\n/g, '\n').trim();
  if (!normalized) return null;

  const rawLines = normalized.split(/\n/).map((l) => l.trim()).filter(Boolean);
  const bulletRegex = /^[-*•]\s+/;
  const bulletCount = rawLines.filter((l) => bulletRegex.test(l)).length;

  if (bulletCount >= 2) {
    const intro: string[] = [];
    const bullets: string[] = [];
    for (const line of rawLines) {
      if (bulletRegex.test(line)) bullets.push(line.replace(bulletRegex, ''));
      else if (bullets.length === 0) intro.push(line);
      else intro.push(line);
    }
    return (
      <div className={`leading-relaxed space-y-2 ${className}`}>
        {intro.length > 0 && <p>{intro.join(' ')}</p>}
        <ul className="list-disc pl-5 space-y-1">
          {bullets.map((b, i) => (
            <li key={i}>{b}</li>
          ))}
        </ul>
      </div>
    );
  }

  const paragraphBreaks = normalized.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
  const paragraphs = paragraphBreaks.length > 1
    ? paragraphBreaks
    : groupSentences(splitIntoSentences(normalized));

  return (
    <div className={`leading-relaxed space-y-2 ${className}`}>
      {paragraphs.map((p, i) => (
        <p key={i}>{p}</p>
      ))}
    </div>
  );
};

export default FormattedSummary;

